import React, {useEffect, useState} from "react";

const TextAreaInput = ({
    className = "",
    labelClassName = "",
    langTitle = "",
    langSubTitle,
    langPlaceholder,
    defaultValue = "",
    onChange,
    errorMessage,
    rows,
}) => {
    const [value, setValue] = useState(defaultValue);

    useEffect(() => setValue(defaultValue), [defaultValue]);

    return (
        <div className={`form-group py-4 m-0 ${className}`}>
            <label className={labelClassName} htmlFor={langTitle}>
                {langTitle}
                {langSubTitle ? <span className="font-size-base text-muted">{langSubTitle}</span> : null}
            </label>
            <textarea
                id={langTitle}
                value={value}
                placeholder={langPlaceholder}
                rows={rows}
                className="form-control form-control-solid h-auto py-5 px-6 border border-gray"
                onChange={e => setValue(e.target.value.replace(/\s/g, ""))}
                onKeyDown={e => {
                    const trimmedValue = e.target.value.replace(/\s/g, "");
                    if (e.key === "Enter") {
                        if (trimmedValue && trimmedValue !== defaultValue) {
                            onChange(trimmedValue);
                        }
                    } else e.target.value = value;
                }}
                onBlur={e => {
                    const trimmedValue = e.target.value.replace(/\s/g, "");
                    if (trimmedValue !== defaultValue) {
                        onChange(trimmedValue);
                    }
                }}
            />
            <p className="text-danger">{errorMessage}</p>
        </div>
    );
};
export default TextAreaInput;
